// Eclipse Cubiertas logo image — raw, no wrapper. PNG has transparent alpha so it
// reads correctly over dark backgrounds (hero, scrolled navbar, footer, admin sidebar).
// `framed` prop kept for backwards compatibility but is now a no-op.
export default function EclipseLogo({ size = "h-12", className = "", alt = "Eclipse Cubiertas - Líderes en Cubiertas Textiles en México" }) {
    return (
        <img
            src="/brand/eclipse_logo.png"
            alt={alt}
            className={`${size} w-auto object-contain ${className}`}
            loading="eager"
            decoding="async"
        />
    );
}
